import { render } from "./SensorTileSkeleton.vue?vue&type=template&id=3da0ff12"
import script from "./SensorTileSkeleton.vue?vue&type=script&lang=js"
export * from "./SensorTileSkeleton.vue?vue&type=script&lang=js"
script.render = render

export default script